module.exports = __webpack_public_path__ + "static/media/logoKancelar.527e140e.png";